/*
 * Copyright (c) 2024, s0up and the autobrr contributors.
 * SPDX-License-Identifier: GPL-2.0-or-later
 */

interface RepoUrls {
  [key: string]: string;
}

export const repoUrls: RepoUrls = {
  "autobrr": "https://github.com/autobrr/autobrr/releases/",
  "omegabrr": "https://github.com/autobrr/omegabrr/releases/",
  "dashbrr": "https://github.com/autobrr/dashbrr/releases/",
  "maintainerr": "https://github.com/jorenn92/Maintainerr/releases/",
  "overseerr": "https://github.com/sct/overseerr/releases/",
  "prowlarr": "https://github.com/Prowlarr/Prowlarr/releases",
  "sonarr": "https://github.com/Sonarr/Sonarr/releases",
  "radarr": "https://github.com/Radarr/Radarr/releases",
};
